import { usePutTranscriptionHistoryApi } from 'api/transcription_history'
import { Flex } from 'components/shared/flex'
import { InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { TranscriptionHistory, TranscriptionHistoryForm } from 'entities/transcription_history'

const FormView = (form: Form<TranscriptionHistoryForm>, apiError: ApiError) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="note" label='Note' />
            </Flex>
        </>
    )
}

type EditTranscriptionHistoryFormProps = {
    transcriptionHistory: TranscriptionHistory
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditTranscriptionHistoryForm = (props: EditTranscriptionHistoryFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutTranscriptionHistoryApi()
    const form = useForm<TranscriptionHistoryForm>({ ...props.transcriptionHistory })

    useEffectSkipFirst(() => {
        form.set(props.transcriptionHistory)
    }, [props.transcriptionHistory])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>TranscriptionHistoryの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.id && (
                    <>
                        <h3 style={{ marginBottom: 10 }}>ID: {props.transcriptionHistory.id}</h3>
                        {FormView(form, api.apiError)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
